export const AUTOCOMPLETE_QUERY_MIN_LENGTH_TO_ACTIVATE = 3;

export const AUTOCOMPLETE_SEARCH_ACTIVATION_DELAY = 250;
